import { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ title, onClose, children, testId }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-6" onClick={onClose}>
      <div
        data-testid={testId}
        className="bg-white w-full sm:max-w-lg max-h-[90vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl border-2 border-foreground/20 p-6 sm:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-extrabold">{title}</h2>
          <button
            data-testid="modal-close-button"
            onClick={onClose}
            aria-label="Close"
            className="min-w-[48px] min-h-[48px] rounded-full border-2 border-foreground/25 grid place-items-center transition-colors duration-200 hover:bg-secondary"
          >
            <X size={24} strokeWidth={2.5} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
